export default __webpack_public_path__ + "static/media/fpb40000.890f69fb.png";